import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextLink"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicNextLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/vercel/path0/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/Layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedArticlesSlider"] */ "/vercel/path0/src/components/RelatedArticlesSlider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Faq/FaqAccordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Forms/CleanerJoinForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Forms/ContactForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/ServiceTabs/ServiceTabsContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/TestimonialCarousel/Testimonials.js");
